<div fxLayout="row" fxLayoutAlign="center center" class="main-container">
  <div fxFlex="100" fxFlex.lt-md="90" fxFlex.lt-sm="100" class="quiz-container" fxLayout="column"  [@fadeIn]>
    <div *ngIf="currentQuestion && !submitted" class="question-container" [@fadeIn]>
      <h2>{{ currentQuestion.label }}</h2>
      <div class="options-container">
        <div class="option" *ngFor="let option of currentQuestion.options.split(',')" fxLayoutAlign="start center" [@fadeIn]>
          <mat-checkbox
            style="color: #000;"
            (change)="selectOption(currentQuestion.fieldId, option)"
            [checked]="isOptionSelected(currentQuestion.fieldId, option)">
            {{ option }}
          </mat-checkbox>
        </div>
      </div>
      <!-- <p *ngIf="selectedAnswers[currentQuestion.fieldId]?.length">Your answer: {{ selectedAnswers[currentQuestion.fieldId][0] }}</p> -->
    </div>

    <div fxLayout="row" fxLayoutAlign="space-between" class="button-container" [@fadeIn] fxLayout.xs="column">
      <button mat-button *ngIf="currentIndex !== 0 && !submitted" (click)="prevQuestion()">Previous</button>
      <button mat-button *ngIf="currentIndex < regConfig.length - 1 && !submitted" (click)="nextQuestion()">Next</button>
      <button mat-button *ngIf="currentIndex === regConfig.length - 1 && !submitted" (click)="submitQuiz()">Submit</button>
    </div>

    <div *ngIf="submitted" class="results-container" [@fadeIn]>
      <h2>Your Score: {{ score }} / {{ regConfig.length }}</h2>
      <button  mat-button *ngIf="showbutton&&!quizCompleted" (click)="viewAnswers()" style="margin: 10px;">View Answers</button>
      
      <div *ngIf="showAnswers">
        <h2>Your Answers:</h2>
        <div *ngFor="let question of regConfig">
          <p><strong>{{ question.label }}</strong></p>
          <p>Your answer: {{ selectedAnswers[question.fieldId][0] }}</p>
          <p>Correct answer: {{ question.customfield5 }}</p>
        </div>
      </div>

      <div *ngIf="!quizCompleted"  fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start center" fxLayout.sm="column" fxLayoutGap.sm="8px">
        <!-- <button mat-button (click)="restartQuiz()" fxFlex>Restart</button> -->
        <button mat-button (click)="confirmSubmission()" fxFlex>Confirm</button>
      </div>
    </div>
  </div>
</div>
